import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { FileText, FileSignature, Clock, CheckCircle2, AlertTriangle, Download } from 'lucide-react';

export function DocumentsKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Tài Liệu',
      value: 1245,
      suffix: 'Bản ghi',
      icon: FileText,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [1100, 1150, 1180, 1200, 1210, 1230, 1245]
    },
    {
      title: 'Chờ Trình Ký',
      value: 12,
      suffix: 'Hồ sơ',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Đã xử lý',
      chartColor: 'bg-amber-500',
      chartData: [20, 18, 15, 14, 15, 13, 12]
    },
    {
      title: 'Đã Ban Hành',
      value: 856,
      suffix: 'Tài liệu',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Mới ban hành',
      chartColor: 'bg-emerald-500',
      chartData: [800, 810, 820, 835, 840, 850, 856]
    },
    {
      title: 'Phiên Bản Mới',
      value: 45,
      suffix: 'Bản thảo',
      icon: FileSignature,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Đang cập nhật',
      chartColor: 'bg-blue-500',
      chartData: [40, 42, 45, 43, 44, 45, 45]
    },
    {
      title: 'Sắp Hết Hạn',
      value: 5,
      suffix: 'Cảnh báo',
      icon: AlertTriangle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'up',
      trendValue: 'Cần gia hạn',
      chartColor: 'bg-red-500',
      chartData: [2, 2, 3, 3, 4, 4, 5]
    },
    {
      title: 'Lượt Truy Cập',
      value: 3.2,
      suffix: 'k Lượt',
      icon: Download,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'up',
      trendValue: 'Tuần qua',
      chartColor: 'bg-purple-500',
      chartData: [2.5, 2.7, 2.6, 2.8, 2.9, 3.1, 3.2]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
